<div style="margin: 20px 20px 0 20px">
  <div style="margin: 0 5% 30px" class="p-d-flex p-ai-center">
    <img
      id="profile-img"
      src="assets/key.png"
      class="profile-img-card p-d-none p-d-md-inline-flex" style="margin-right:20px;"
    />
    <span style="font-size:30px;text-align:center">Change Password</span>
  </div>

  <form
    name="form"
    (ngSubmit)="f.form.valid && onSubmit()"
    #f="ngForm"
    novalidate
  >
    <div class="p-fluid p-formgrid p-grid">

      <div class="p-field p-col-12 p-md-5" style="margin-top:8px">
        <span>Current password:</span>
      </div>
      <div class="p-field p-col-12 p-md-7">
        <p-password
          name="passwordOld"
          [(ngModel)]="form.passwordOld"
          required
          minlength="6"
          #passwordOld="ngModel"
          [toggleMask]="true"
          [feedback]="false"
        >
        </p-password>
        <div class="alert" *ngIf="passwordOld.errors && f.submitted">
          <div *ngIf="passwordOld.errors.required">Old Password is required</div>
          <div *ngIf="passwordOld.errors.minlength">
            Password must be at least 6 characters
          </div>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-5" style="margin-top:8px">
        <span>New password:</span>
      </div>
      <div class="p-field p-col-12 p-md-7">
        <p-password
          name="passwordNew"
          [(ngModel)]="form.passwordNew"
          required
          minlength="6"
          inline="true"
          #passwordNew="ngModel"
          [toggleMask]="true"
        >
        </p-password>
        <div class="alert" *ngIf="passwordNew.errors && f.submitted">
          <div *ngIf="passwordNew.errors.required">New password is required</div>
          <div *ngIf="passwordNew.errors.minlength">
            Password must be at least 6 characters
          </div>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-5">
        <span>Confirm password:</span>
      </div>
      <div class="p-field p-col-12 p-md-7">
        <p-password
          name="passwordConfirm"
          [(ngModel)]="form.passwordConfirm"
          required
          #passwordConfirm="ngModel"
          [toggleMask]="true"
          [feedback]="false"
        >
        </p-password>
        <div class="alert" *ngIf="passwordConfirm.errors && f.submitted">
          <div *ngIf="passwordConfirm.errors.required">Password confirmation is required</div>
        </div>
        </div>

      <div class="p-field p-col-12 p-md-12">
        <Input class="button_black" Type="Submit" *ngIf="f.dirty" Value="Change Password" style="width:100%; height:35px;" />
      </div>

      <div class="form-group" style="padding-top: 10px">
        <div class="alert" *ngIf="f.submitted && isChangeFailed">
          Password change failed: {{ errorMessage }}
        </div>
      </div>
    </div>
  </form>
</div>

<img class="progress-spinner rotate" *ngIf="isBusy" src="assets/loading.png" alt="loading...">

